import {Directive, HostBinding, Input, SimpleChanges} from '@angular/core';

@Directive({
  selector: 'a[publicationLink]'
})
export class PublicationLinkDirective {
  @HostBinding('target') target: string;
  @HostBinding('href') href?: string;
  @HostBinding('innerText') innerText?: string;

  @Input() bibCode: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.bibCode) {
      this.target = '_blank';
      this.href = `https://ui.adsabs.harvard.edu/?#abs/${this.bibCode}`;
      this.innerText = this.bibCode;
    }
  }
}
